











































































































































































import {Component, Mixins} from 'vue-property-decorator'
import GlyphCustom from '../components/lib/GlyphCustom.vue'
import IconCustom from '../components/lib/IconCustom.vue'
import TravelsPreviewSection from '../components/TravelsPreviewSection.vue'
import ServicesPreviewSection from '../components/ServicesPreviewSection.vue'
import PartnersSection from '../components/PartnersSection.vue'
import ButtonCommon from '../components/lib/ButtonCommon.vue'
import ContactForm from '../components/contact/ContactForm.vue'
import i18n from '@/i18n';
import {onLoadJumpMixin} from '../mixins/onScrollAnimationMixin'
import {IPlatformInfo, IPlatformSocial} from '../entities'

@Component({
  components: {
    GlyphCustom,
    IconCustom,
    TravelsPreviewSection,
    ServicesPreviewSection,
    PartnersSection,
    ButtonCommon,
    ContactForm,
  },
  metaInfo(): Object {
    return {
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('home.meta-info.description')
        }
      ]
    }
  }
})
export default class Home extends Mixins(onLoadJumpMixin) {

  mounted() {
    this.$store.dispatch('setCheckboxLabelColor', true);
  }

  private socialsToShow: string[] = [
    'facebook',
    'instagram',
    'telegram',
    'whatsapp'
  ];

  private stepsNumber: number = 4;
  private stepContentNumber: number = 2;

  get platform(): IPlatformInfo {
    return this.$storage.getters.getPlatformInfo()
  }

  get socials(): IPlatformSocial[] {
    return this.platform.social?.filter((social: IPlatformSocial) => this.socialsToShow.indexOf(social.name) !== -1) || [];
  }

  get email(): string {
    return this.platform.email;
  }
  get isRus():boolean{
      const state = i18n.locale === 'ru'? true: false
      return state
  }

  get name(): string {
    return this.platform.name;
  }
  get sherpaLink(): string {
    return `https://apply.joinsherpa.com/travel-restrictions?language=${i18n.locale}`
  }
  private linkTelegram(): void {
      window.open('https://t.me/bonifiquenews');
  } 
  private getConsultation(): void {
    this.$storage.actions.setModal({
      name: 'ModalConsultation',
      from: 'alt'
    });
  }

  private getCustomPlan(): void {
    this.$storage.actions.setModal({
      name: 'ModalPlan',
      from: 'alt'
    });
  }

  private getPromoCode(): void {
    this.$storage.actions.setModal({
      name: 'ModalCertificate',
      from: 'home'
    });
  }

}
